<span
  evcTooltipVisible="visible"
  evcTooltipPlacement="top"
  [evcTooltipHover]="name()">
  <evc-button
    type="primary"
    size="small"
    frame="ghost"
    [icon]="icon()">
  </evc-button>
</span>
